import { defineStore } from 'pinia';

export const useVersionStore = defineStore('version', {
	state: () => ({
		latest_release_information: null,
		is_out_of_date: false,
	}),
	actions: {
		setLatestReleaseInformation(release_information) {
			this.latest_release_information = release_information;
		},
		clearLatestReleaseInformation() {
			this.latest_release_information = null;
		},
		setOutOfDate(status) {
			this.is_out_of_date = !!status;
		},
	},
});
